import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Modal } from 'antd';
import { createSendHeaderImgData } from '../../../../utils/createSendHeaderImgData';

const { confirm } = Modal;

const StateContext = createContext();
const ActionsContext = createContext();

export const useHeaderImgState = () => useContext(StateContext);
export const useHeaderImgActions = () => useContext(ActionsContext);

const initialState = { isDeleted: false, value: null };

export const Provider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const stateRef = useRef(state);

  useEffect(() => {
    stateRef.current = state;
  }, [state]);

  const getResult = useCallback(() => {
    const state = stateRef.current;
    if (!state.value) return state;

    const { initialCroppedArea, ...other } = state.value;
    const value = createSendHeaderImgData({ ...other, ...initialCroppedArea });

    return {
      ...state,
      value,
    };
  }, []);

  const reset = useCallback(() => {
    setState(initialState);
  }, []);

  const onCropOk = useCallback(
    ({ file, zoom, croppedArea, croppedFile }, reset) => {
      setState({
        isDeleted: false,
        value: {
          file,
          zoom,
          initialCroppedArea: croppedArea,
          croppedFile,
        },
      });

      reset();
    },
    []
  );

  const onDelete = (hasImg) => {
    confirm({
      title: 'Удалить изображение?',
      okText: 'Удалить',
      okType: 'danger',
      onOk: () => {
        setState({ hasImg, isDeleted: true, value: null });
      },
      onCancel: () => {},
    });
  };

  const actions = useMemo(
    () => ({ getResult, reset, onCropOk, onDelete }),
    [getResult, reset, onCropOk, onDelete]
  );

  return (
    <StateContext.Provider value={state}>
      <ActionsContext.Provider value={actions}>
        {children}
      </ActionsContext.Provider>
    </StateContext.Provider>
  );
};
